import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "./../../components/panel/panel.jsx";
import React, { useState } from "react";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import "react-datetime/css/react-datetime.css";
import { useParams } from "react-router-dom";
import ToggleSwitch from "../../components/CustomComponents/Switchery/switchery.jsx";
import CommonTimeSlotForAllWeek from "../../components/CustomComponents/TimeSchedule/commonTimeSlotForAllWeek.js";
import ScheduleManager from "../../components/CustomComponents/TimeSchedule/weeklySlots.js";
import schedule from "../../components/CustomComponents/TimeSchedule/schedule.js";

function WeeklySchedule() {
  const { UserName } = useParams();
  const [regularHours, setRegularHours] = useState(true);
  const [useSameTimeSlots, setUseSameTimeSlots] = useState(true);
  const [commonTimeSlot, setCommonTimeSlot] = useState([
    {
      from: "12:00 AM",
      to: "11:59 PM",
    },
  ]);
  const [schedules, setSchedules] = useState(schedule);

  const applyCommonTimeSlotToAll = () => {
    const updatedSchedules = schedules.map((schedule) => ({
      ...schedule,
      timeSlots: commonTimeSlot.map((slot) => ({ ...slot })),
    }));
    setSchedules(updatedSchedules);
  };

  const handleSubmit = () => {
    const formattedSchedule = Object.keys(schedule).reduce((acc, day) => {
      acc[day] = {
        open: schedule[day].open ? schedule[day].open.format("hh:mm A") : "",
        close: schedule[day].close ? schedule[day].close.format("hh:mm A") : "",
      };
      return acc;
    }, {});
 
  };

  return (
    <div>
      <div className="d-flex align-items-center mb-2 mt-2">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/team/manageTeam">Manage Staff</Link>
            </li>
            <li className="breadcrumb-item active">Weekly Schedule</li>
          </ol>
          <h1 className="page-header mb-0">Weekly Schedule ({UserName})</h1>
        </div>
        <div className="ms-auto">
          <button
            className="btn btn-success btn-rounded px-4 rounded-pill"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
      <div className="card border-0">
        <Panel className="m-3">
          <PanelHeader>General</PanelHeader>
          <PanelBody>
            <div className="col-8">
              <ToggleSwitch
                isChecked={regularHours}
                onToggle={() => setRegularHours(!regularHours)}
                label={"Available Standard Restaurant Busines Hours"}
                disabled={false}
              />
            </div>
            <div className="row m-3">
              {regularHours ? (
                <></>
              ) : (
                <>
                  <div className="mb-3">
                    <ToggleSwitch
                      isChecked={useSameTimeSlots}
                      onToggle={() => {
                        setUseSameTimeSlots(!useSameTimeSlots);
                        if (!useSameTimeSlots) {
                          applyCommonTimeSlotToAll();
                        }
                      }}
                      label={"Use same time slots for all days"}
                      disabled={false}
                    />
                  </div>
                  {useSameTimeSlots ? (
                    <CommonTimeSlotForAllWeek
                      setCommonTimeSlots={setCommonTimeSlot}
                      commonTimeSlots={commonTimeSlot}
                    />
                  ) : (
                    <ScheduleManager
                      schedules={schedules}
                      setSchedules={setSchedules}
                    />
                  )}
                </>
              )}
            </div>
          </PanelBody>
        </Panel>
      </div>
    </div>
  );
}
export default WeeklySchedule;  
